import { useMemo } from 'react'
import { Box } from '@mui/material'
import Pressable from '@/theme/Pressable'
import PrimaryNavAccountMenu from '@/components/AccountMenu/PrimaryNavAccountMenu'
import { AccountMenuHeaderSlot } from '@/components/AccountMenu/AccountMenuHeaderSlot'
import { ACCOUNT_MENU_LIST_ID } from '@/components/AccountMenu/primaryNavConstants'
import { usePrimaryNavAccountMenu } from '@/components/AccountMenu/usePrimaryNavAccountMenu'
import accountMenuStyles from '@/components/AccountMenu/accountMenu.module.scss'
import styles from './SecondaryNavAccountFooter.module.scss'

export default function SecondaryNavAccountFooter({
  onAccountMenuAction,
  accountFullName,
  accountEmail,
}) {
  const account = usePrimaryNavAccountMenu({ onAccountMenuAction })
  const accountMenuHeader = useMemo(
    () => <AccountMenuHeaderSlot accountFullName={accountFullName} accountEmail={accountEmail} />,
    [accountFullName, accountEmail],
  )

  return (
    <Box className={styles.footer}>
      <Pressable
        className={`${accountMenuStyles.avatarShell} ${accountMenuStyles.avatarShellButton}`}
        aria-label="Account menu"
        aria-haspopup="menu"
        aria-expanded={account.accountMenuOpen}
        aria-controls={account.accountMenuOpen ? ACCOUNT_MENU_LIST_ID : undefined}
        onClick={account.handleAccountMenuOpen}
      >
        <Box className={accountMenuStyles.avatarFill} aria-hidden />
      </Pressable>
      <PrimaryNavAccountMenu
        accountMenuOpen={account.accountMenuOpen}
        accountMenuAnchor={account.accountMenuAnchor}
        accountMenuHeader={accountMenuHeader}
        accountMenuItems={account.accountMenuItems}
        onClose={account.handleAccountMenuClose}
        onItemSelect={account.handleAccountItemSelect}
      />
    </Box>
  )
}
